
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/experiencia/[slug]",
      function () {
        return require("private-next-pages/experiencia/[slug].tsx");
      }
    ]);
  